const navLinks = document.querySelectorAll('.card-list__nav-link');
if (navLinks.length > 0) {
  window.addEventListener('load', () => {
    navLinks.forEach((link) => {
      const linkId = link.getAttribute('href');

      if (linkId && linkId !== '#') {
        const sectionElem = document.querySelector(linkId);

        if (sectionElem) {
          gsap.timeline({
            scrollTrigger: {
              trigger: sectionElem,
              start: 'top center',
              end: 'bottom center',
              scrub: true,
              toggleClass: { targets: link, className: 'is-active' },
            },
          });
        }
      }
    });
  });

  const updateMaxWidth = () => {
    const cardNabLinks = document.querySelectorAll('.card-list__nav-link');
    const maxWidth = Math.max(...Array.from(cardNabLinks).map((l) => l.offsetWidth));
    document.querySelector('.card-list__content')?.style.setProperty('--max-width', `${maxWidth}px`);
  };

  const debouncedWidthUpdate = debounce(updateMaxWidth, 150);

  updateMaxWidth();
  window.addEventListener('resize', debouncedWidthUpdate);
}

// Scroll back to clicked card
document.querySelectorAll('.card').forEach((card) => {
  card.addEventListener('click', () => {
    sessionStorage.setItem('lastCard', card.id);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const lastCard = sessionStorage.getItem('lastCard');

  if (lastCard) {
    const el = document.getElementById(lastCard);
    el?.scrollIntoView({ behavior: 'instant', block: 'center' });
    sessionStorage.removeItem('lastCard');
  }
});
